import Banner from './views/Banner';
export default Banner;
